import type {
	PresentationJson,
	PresentationJsonSlide,
} from "./presentationJson";

type SlideDisplayStateTemplate<Tag extends string> = {
	tag: Tag;
	displayState: DisplayState;
	presentation: PresentationJson;
	currentSlide: PresentationJsonSlide;
	slideIndex: number;
};

type QAndAState = {
	answer: {
		audioPath: string;
		videoPath: string | undefined;
	};
};

export enum SlideDisplayTag {
	FIRST_SLIDE_PAUSED = "FIRST_SLIDE_PAUSED",
	FIRST_SLIDE_PLAYING = "FIRST_SLIDE_PLAYING",
	PLAYING = "PLAYING",
	PAUSED = "PAUSED",
	LAST_SLIDE_PAUSED = "LAST_SLIDE_PAUSED",
	LAST_SLIDE_PLAYING = "LAST_SLIDE_PLAYING",
	LAST_SLIDE_FINISHED = "LAST_SLIDE_FINISHED",
	Q_AND_A = "Q_AND_A",
}
export type FirstSlidePaused =
	SlideDisplayStateTemplate<SlideDisplayTag.FIRST_SLIDE_PAUSED>;
export type FirstSlidePlaying =
	SlideDisplayStateTemplate<SlideDisplayTag.FIRST_SLIDE_PLAYING>;
export type PlayingSlide = SlideDisplayStateTemplate<SlideDisplayTag.PLAYING>;
export type PausedSlide = SlideDisplayStateTemplate<SlideDisplayTag.PAUSED>;
export type LastSlidePaused =
	SlideDisplayStateTemplate<SlideDisplayTag.LAST_SLIDE_PAUSED>;
export type LastSlidePlaying =
	SlideDisplayStateTemplate<SlideDisplayTag.LAST_SLIDE_PLAYING>;
export type LastSlideFinished =
	SlideDisplayStateTemplate<SlideDisplayTag.LAST_SLIDE_FINISHED>;
export type ReadQAndA = SlideDisplayStateTemplate<SlideDisplayTag.Q_AND_A> &
	QAndAState;

export type SlideDisplayState =
	| FirstSlidePaused
	| FirstSlidePlaying
	| PlayingSlide
	| PausedSlide
	| LastSlidePaused
	| LastSlidePlaying
	| LastSlideFinished
	| ReadQAndA;

export type DisplayState = {
	subtitlesVisible: boolean;
};
